import {Alert, Button} from 'antd';
import {useMutation, useQuery} from 'react-query';
import api from '../../api';
import {queryClient} from '../../utils/react-query';


const InvitationSendingForm = ({...props}) => {
  const {data: {data: itemData = []} = {}} = useQuery(['meeting', props.meeting],
    async () => {
      return await api.meetings.meetingControlRetrieve(props.meeting);
    }, {
      enabled: !!props.meeting,
      refetchInterval: 10000,
      cacheTime: Infinity,
    });

  const {mutateAsync: mutateAsyncUpdate} = useMutation(
    api.meetings.meetingActivateSending, {
      onSuccess: async () => {
        await queryClient.removeQueries(['meeting', props.meeting]);
      }
    });

  const startSending = async () => {
    await mutateAsyncUpdate({meetingId: props.meeting});
  }

  const invitationCount = itemData?.invitation_cnt || 0;
  const invitationLabel = invitationCount === 1 ? 'Einladung' : 'Einladungen';
  const readyMessage = `${invitationCount} ${invitationLabel} ${invitationCount === 1 ? 'ist' : 'sind'} zum Versand bereit.`;
  const sendButtonLabel = `${invitationCount} ${invitationLabel} jetzt versenden`;
  const sentMessage = `${invitationCount} ${invitationLabel} ${invitationCount === 1 ? 'wurde' : 'wurden'} erfolgreich an den Mailserver übergeben.`;

  return <div>
    <h3 className="title">E-Mail schicken</h3>
    <hr className="hr"/>
    {itemData.sending_status === 'CREATED' &&
      <>
        <Alert message={readyMessage} type="info"
               style={{marginBottom: '20px'}}/>
        <Button style={{marginBottom: '20px'}} onClick={startSending}
                disabled={invitationCount === 0}>
          {sendButtonLabel}
        </Button>
      </>
    }

    {itemData.sending_status === 'READY' &&
      <>
        <Alert message={readyMessage} type="info"
               style={{marginBottom: '20px'}}/>
        <p>
          Der Versand wurde gestartet. Sobald der Versandprozess läuft, wird der Status aktualisiert.
        </p>
      </>
    }

    {itemData.sending_status === 'PROCESSING' &&
      <>
        <Alert message="Einladungen in Bearbeitung" type="info"
               style={{marginBottom: '20px'}}/>
        <p>
          Die Einladungen werden gerade an den Mailserver übergeben.
        </p>
      </>
    }

    {itemData.sending_status === 'COMPLETED' && invitationCount > 0 &&
      <>
        <Alert message={readyMessage} type="info"
               style={{marginBottom: '20px'}}/>
        <Button style={{marginBottom: '20px'}} onClick={startSending}>
          {sendButtonLabel}
        </Button>
      </>
    }

    {itemData.sending_status === 'COMPLETED' && invitationCount === 0 &&
      <>
        <Alert message={sentMessage} type="success"
               style={{marginBottom: '20px'}}/>
        <p>Versandstatus und Versanddatum wurden aktualisiert.</p>
        <Button style={{marginBottom: '20px'}} onClick={startSending}>
          Einladungen erneut versenden
        </Button>
      </>
    }

    <hr className="hr"/>

  </div>
}

export default InvitationSendingForm;
